/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { formatNumber } from 'cio/helpers/format-number';
import { Measure } from 'cio/utils/metrics/common';
import pluralize from 'cio/utils/pluralize';

interface MultiMetricUnsubscribeArgs {
  measure: Measure;
  channelItem: {
    numeratorValue: number;
    denominator: number;
    denominatorValue: number;
    denominatorLabel: string;
  };
}

export default class MultiMetricUnsubscribe extends Component<MultiMetricUnsubscribeArgs> {
  get summaryStatement() {
    let title = formatNumber([this.args.channelItem.numeratorValue]);
    if (this.args.measure === 'topic_unsubscribed') {
      title += ' topic';
    }
    let total = pluralize(this.args.channelItem.numeratorValue, 'unsubscribe', 'unsubscribes');
    title += ` ${total} out of ${formatNumber([this.args.channelItem.denominatorValue])} `;
    title += this.args.channelItem.denominatorLabel.toLowerCase();
    return title;
  }
}
